import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '../amfe-flexible'
import 'bootstrap/dist/css/bootstrap.css' // bootstrap
import './assets/styles/index.scss' // 全局样式

createApp(App).use(router).mount('#app')
